import { BrowserAgent } from '@newrelic/browser-agent'

export const newRelicOptions = {
  info: {
    applicationID: Number(process.env.REACT_APP_NEW_RELIC_APPLICATION_ID) || 1431968468,
    beacon: process.env.REACT_APP_NEW_RELIC_BEACON || 'bam.nr-data.net',
    errorBeacon: process.env.REACT_APP_NEW_RELIC_ERROR_BEACON || 'bam.nr-data.net',
    licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || 'NRJS-3b76f6c7ed1a7b0c62b',
    sa: 1
  },
  init: {
    ajax: {
      deny_list: [
        'bam.nr-data.net'
      ]
    },
    browser_consent_mode: {
      enabled: false
    },
    distributed_tracing: {
      enabled: true
    },
    performance: {
      capture_detail: false,
      capture_marks: false,
      capture_measures: true
    },
    privacy: {
      cookies_enabled: true
    }
  },
  loader_config: {
    accountID: Number(process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID) || 8573047,
    agentID: Number(process.env.REACT_APP_NEW_RELIC_APPLICATION_ID) || 1431968468,
    applicationID: Number(process.env.REACT_APP_NEW_RELIC_APPLICATION_ID) || 1431968468,
    licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || 'NRJS-3b76f6c7ed1a7b0c62b',
    trustKey: Number(process.env.REACT_APP_NEW_RELIC_TRUST_KEY) || 8573047
  }
}

let agent = null
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test' && process.env.REACT_APP_NEW_RELIC_ENABLED !== 'false') {
  agent = new BrowserAgent(newRelicOptions)
}

export const nrba = agent
export default nrba
